import { BlockStack, Button, InlineStack } from '@shopify/polaris';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import BoldText from '@/components/BoldText';
import LayoutSettings from '@/components/LayoutSetting/LayoutSettings';
import RegularText from '@/components/RegularText';
import { deliverySettingSelector } from '@/redux/slice/delivery.slice';
import { useSelector } from 'react-redux';
import ModalEditZone from './ModalEditZone';

export type TRegion = {
  value: string;
  label: string;
};

type DeliveryLocationProps = {
  locationCities: TRegion[];
  detailLocation?: {
    name?: string;
    address1?: string;
    city?: string;
    postalCode?: string;
  };
};

const DeliveryLocation: FC<DeliveryLocationProps> = ({ locationCities, detailLocation }) => {
  const { t } = useTranslation('deliverySettings');
  const deliverySettings = useSelector(deliverySettingSelector);

  const [isShowEditZone, setEditZone] = useState(false);

  return (
    <>
      <LayoutSettings
        title={t('sections.locationAddress.title')}
        helpText={t('sections.locationAddress.helpText')}
        children={
          <BlockStack gap={'400'}>
            <BlockStack gap={'200'}>
              <BoldText>{t('sections.locationAddress.storeLocation')}</BoldText>
              <BlockStack>
                <RegularText as="p">{detailLocation?.name || t('sections.locationAddress.defaultLocation')}</RegularText>
                <RegularText as="p">
                  {`${detailLocation?.address1 || t('sections.locationAddress.defaultAddress')}, `}
                  {detailLocation?.city || t('sections.locationAddress.defaultAddress')}
                  {detailLocation?.postalCode ? `, ${detailLocation.postalCode}` : ''}
                </RegularText>
              </BlockStack>
            </BlockStack>
            <InlineStack align="space-between" blockAlign="start">
              <BlockStack gap={'200'}>
                <BoldText>{t('sections.locationAddress.deliveryZone')}</BoldText>
                <div>
                  <RegularText as="p">{deliverySettings?.name || t('sections.locationAddress.defaultZone')}</RegularText>
                  <RegularText as="p">{deliverySettings?.city || t('sections.locationAddress.city')}</RegularText>
                </div>
              </BlockStack>
              <Button variant="plain" onClick={() => setEditZone(true)}>
                {t('sections.locationAddress.editSettings')}
              </Button>
            </InlineStack>
          </BlockStack>
        }
      />
      <ModalEditZone isShowModal={isShowEditZone} locationCities={locationCities} onHide={() => setEditZone(false)} />
    </>
  );
};

export default DeliveryLocation;
